module.exports = __webpack_public_path__ + "img/menu_ladies_ibiki.78195a49.webp";